import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { AnnouncementTitle } from '../announcement-title'
import type { ModalBlockAlign, ModalHeadingSize } from './modal-block-types'

type ModalHeadingBlockProps = {
  text: ReactNode
  highlight?: string
  centerOnMobile?: boolean
  align?: ModalBlockAlign
  size?: ModalHeadingSize
}

export const ModalHeadingBlock = ({
  text,
  highlight,
  align,
  size,
  centerOnMobile,
}: ModalHeadingBlockProps) => (
  <Typography
    component="h4"
    // The element stays an h4 at either size: the size is a visual weight, not
    // a change to the dialog's outline.
    variant={size === 'large' ? 'h3' : 'h4'}
    className={cn(
      'w-full whitespace-pre-line [overflow-wrap:anywhere]',
      // A 40px headline on a phone-width dialog wraps every second word.
      size === 'large' && 'sm:text-2xl',
      align === 'left' && 'text-left',
      align === 'center' && 'text-center',
      centerOnMobile === true && 'sm:text-center',
    )}
  >
    {typeof text === 'string' && highlight !== undefined ? (
      <AnnouncementTitle
        highlight={highlight}
        title={text}
      />
    ) : (
      text
    )}
  </Typography>
)
